import { render, staticRenderFns } from "./dashboardOld.vue?vue&type=template&id=190ec91b&scoped=true"
import script from "./dashboardOld.vue?vue&type=script&lang=js"
export * from "./dashboardOld.vue?vue&type=script&lang=js"
import style0 from "./dashboardOld.vue?vue&type=style&index=0&id=190ec91b&prod&lang=scss"
import style1 from "./dashboardOld.vue?vue&type=style&index=1&id=190ec91b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190ec91b",
  null
  
)

export default component.exports